import { defineComponent as _defineComponent } from 'vue'
import { ref, toRefs } from 'vue';
  import Modal from '@/components/common/Modal.vue';
  import BaseText from '@ui/atoms/baseText/BaseText.vue';
  import { BaseSlider } from '@ui/atoms/baseSlider';

  
  const __default__ = {
    name: 'PlaylistItemAudioModal',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    playlistItem: { type: null, required: true }
  },
  emits: ["close", "save"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'close'): void;
    (
      event: 'save',
      data: { wid: string; assocId: number; overrideId?: number; mute: boolean; volume: number },
    ): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { playlistItem: any };

  
  const { playlistItem } = toRefs(props);

  

  const isMuted = ref<boolean>(playlistItem.value?.mute ? true : false);
  const volumeValue = ref<number>(
    playlistItem.value?.volume ? Math.round(playlistItem.value?.volume * 100) : 100,
  );

  function close() {
    emit('close');
  }

  function save() {
    emit('save', {
      wid: playlistItem.value.wid,
      assocId: playlistItem.value.assoc_id,
      overrideId: playlistItem.value.override?.id,
      mute: isMuted.value,
      volume: volumeValue.value / 100,
    });

    close();
  }

  function handleVolume(value: number) {
    volumeValue.value = value;
  }

return { __sfc: true,props, playlistItem, emit, isMuted, volumeValue, close, save, handleVolume, Modal, BaseText, BaseSlider }
}

})